import { Base } from '../core/base.model';
import { DenunciaEvidencia } from './denuncia-evidencia.model';

export enum TipoDenuncia {
  ANONIMA      = 'ANONIMA',
  CONFIDENCIAL = 'CONFIDENCIAL'
}

export enum EstatusDenuncia {
  RECIBIDA         = 1,
  EN_INVESTIGACION = 2,
  CERRADA          = 3
}

export class Denuncia extends Base {
  id_denuncia:              number;
  codigoSeguimiento:        string;
  tipoDenuncia:             TipoDenuncia;
  id_categoria:             number;
  nombreCategoria:          string;
  hechos:                   string;
  requiereProteccion:       string;
  lugarOcurrencia:          string;
  idEstatusAnterior:        number;
  id_estatus:               EstatusDenuncia;
  nombreEstatus:            string;
  fechaRegistro:            Date;
  fechaUltimaActualizacion: Date;
  id_usuarioAsignado:       number;
  nombreUsuarioAsignado:    string;

  // Solo para tipo CONFIDENCIAL
  nombre:    string;
  apellidos: string;
  telefono:  string;
  email:     string;
  captchaToken: string;

  evidencias: DenunciaEvidencia[];
}
